import "./App.css";
import "./dist/bului.css";
import React, { useContext, useEffect } from "react";
import Header from "./components/Header";
import { Routes, Route, useLocation } from "react-router-dom";
import SubHeader from "./components/SubHeader";
import LandingPage from "./pages/LandingPage/LandingPage";
import Footer from "./components/Footer";
import SubjectDashboardPage from "./pages/DashboardPage/SubjectDashboardPage";
import ModerationVisitRequestForm from "./pages/VisitForm/ModerationVisitRequestForm";
import ReviewVisitRequest from "./pages/VisitForm/ReviewVisitRequest";
import MarkSubmissionLandingPage from "./pages/MarkSubmission/MarkSubmissionLandingPage";
import { UnitsProvider } from "./context/UnitsContext";
import {ConsortiaCenterProvider} from "./context/ConsortiaCenterContext";
import { useSubject } from "./context/SubjectContext";
import { ModerationWindowDatesProvider } from "./context/ModerationWindowDatesContext";
import ConfirmationPage from "./pages/ConfirmationPage/ConfirmationPage";
import MarksEntryPage from "./pages/MarkSubmission/MarksEntryPage";
import UpdateMarksEntryPage from "./pages/UpdateMarkSubmission/UpdateMarksEntryPage";
import UnAuthorizedAccess from "./pages/UnAuthorizedPage/UnAuthorizedAccess";
import MarkSubmissionViewPage from "./pages/MarkSubmission/MarkSubmissionViewPage";
import ACMarksDashboardPage from "./pages/AssessmentCriteriaPage/ACMarksDashboardPage";
import ACUpdateMarksDashboardPage from "./pages/UpdateAssessmentCriteria/ACUpdateMarksDashboardPage";
import { CenterContext, CenterProvider } from "./context/CenterContext";
import { useAuth } from "react-oidc-context";
import ReportsLandingPage from "./pages/Reports/ReportsLandingPage";
import MarkSubmissionUpdateMarks from "./components/MarkSubmission/MarkSubmissionUpdateMarks";
import UpdateTotalMarksViewPage from "./components/ACUpdateMarkSubmission/UpdateTotalMarksViewPage";


function logout() {
  localStorage.clear();

  window.location.href = process.env.REACT_APP_MY_CAMBRIDGE_LOGOUT_LINK;
}

function AppContent() {
  const { subjectData } = useSubject();
  const subjectId = subjectData?.selectedSubjectId;
  const location = useLocation();

  const auth = useAuth();

  useEffect(() => {
    const tokenExpiresAt = auth.user?.expires_at;
    const now = Date.now();
    const timeUntilExpiry = tokenExpiresAt * 1000 - now;

    const saveBeforeExpiration = timeUntilExpiry - 60000;

    if (saveBeforeExpiration <= 0) {
     
      logout();
      return;
    }

    const timeoutId = setTimeout(() => {
      
      logout();
    }, saveBeforeExpiration);

    return () => clearTimeout(timeoutId);
  }, [auth.user?.expires_at]);

  const userCtx = useContext(CenterContext) || {};
  const roles = Array.isArray(userCtx.roles) ? userCtx.roles : [];
  const businessStream = Array.isArray(userCtx.businessStream)
    ? userCtx.businessStream
    : [];
  const loadingUser =
    typeof userCtx.loading === "boolean" ? userCtx.loading : true;

  const roleSet = new Set(roles);
  const isOcr = businessStream.includes("OCR");
  const hasTeacher =
    (roleSet.has("EXAMS_OFFICER") || roleSet.has("TEACHER")) && isOcr;

  if (auth.isLoading) {
    return <div>Initializing authentication...</div>;
  }
  if (!auth.isAuthenticated) {
    return <div>Redirecting to login...</div>;
  }

  if (loadingUser) {
    return (
      <div className="App">
        <div className="App-header">
           <Header />
          <SubHeader />
        </div>
        <div className="App-body">
          <div className="spinner">Loading user data...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="App-header">
         <Header />
        <SubHeader />
      </div>
      <div className="header-space" />
      <div className="App-body">
        <Routes>
          {hasTeacher ? (
            <>
              <Route index element={<LandingPage />} />
              <Route path="/dashboard" element={<SubjectDashboardPage />} />
              <Route
                path="/dashboard/marks_submission/:subject"
                element={
                   <UnitsProvider subjectId={subjectId}>
                <MarkSubmissionLandingPage />
                </UnitsProvider>
              }
              />
              <Route
                path="/dashboard/reports/:subject"
                element={<ReportsLandingPage />}
              />
              <Route
                path="/dashboard/marks_submission/:subject/:unit"
                element={<MarksEntryPage />}
              />
              <Route
                path="/dashboard/marks_submission-submitted/:subject/:unit"
                element={<MarkSubmissionViewPage />}
              />
               <Route
                path="/dashboard/update_marks_submission/:subject/:unit"
                element={<UpdateMarksEntryPage />}
              />
              <Route
                path="/dashboard/marks_submissions_update/:subject/:unit"
                element={<MarkSubmissionUpdateMarks />}
              />
              <Route
                path="/dashboard/visit_form/:subject"
                element={
                  <ModerationWindowDatesProvider>
                    <UnitsProvider subjectId={subjectId}>
                      <ModerationVisitRequestForm />
                    </UnitsProvider>
                  </ModerationWindowDatesProvider>
                }
              />
              <Route
                path="/dashboard/visit_form/review_visit/:subject"
                element={
                  <UnitsProvider subjectId={subjectId}>
                    <ReviewVisitRequest />
                  </UnitsProvider>
                }
              />
              <Route
                path="/dashboard/visit_form/submitted/:subject"
                element={<ConfirmationPage />}
              />
              <Route
                path="/dashboard/ac_marks_submission/:subject/:unit"
                 element={
                    <UnitsProvider subjectId={subjectId}>
                      <ACMarksDashboardPage />
                    </UnitsProvider>
                }
              />
              <Route
                path="/dashboard/ac_update_marks_submission/:subject/:unit"
                element={
                <ACUpdateMarksDashboardPage />}
              />
               <Route
                path="/dashboard/view_update_marks_submission/:subject/:unit"
                element={<UpdateTotalMarksViewPage />}
              />

            </>
          ) : (
            <Route path="/*" element={<UnAuthorizedAccess />} />
          )}
        </Routes>
      </div>
      {location.pathname === "/" && <hr />}
      {location.pathname === "/" && <Footer />}
    </div>
  );
}

function App() {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated) {
      auth.signinRedirect();
    }
  }, [auth.isLoading, auth.isAuthenticated, auth]);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (!auth.isAuthenticated) {
    return <div>Redirecting to login...</div>;
  }

  return (
    <ConsortiaCenterProvider>
    <CenterProvider>
      <AppContent />
    </CenterProvider>
    </ConsortiaCenterProvider>
  );
}

export default App;
